import { memo } from 'react';
import { formatTime } from '../../lib/format';
import { cn } from '../../lib/utils';

interface TimestampProps {
  timestamp: number;
  className?: string;
}

export const Timestamp = memo(function Timestamp({ timestamp, className }: TimestampProps) {
  return (
    <time
      data-testid="timestamp"
      dateTime={new Date(timestamp).toISOString()}
      className={cn('text-3xs tabular-nums text-muted-foreground', className)}
    >
      {formatTime(timestamp)}
    </time>
  );
});
